module.exports = __webpack_public_path__ + "static/image-xpnd-7c371ddd89fea49b5074a3b0a503d13b.jpg";